import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  ButtonGroup,
  Paper,
  FormControlLabel,
  Checkbox,
  Popover,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Avatar,
  List,
  CircularProgress,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  InputAdornment,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  IconButton,
  Chip,
  Tooltip,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  SupervisedUserCircle,
  ArrowForwardIos,
  AssistantPhoto,
  Close,
  CheckCircle,
  Block,
  Edit,
  Delete,
  BusinessCenter,
  AccountBalance,
  Schedule,
  Person,
  Money,
  VpnLock,
  AccountCircle,
  Settings,
  CallMade,
  CallReceived,
  AcUnit,
  InfoOutlined,
  BusinessCenterOutlined,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import Empty from "../../../../../assets/svg/empty.svg";
import Format from "date-fns/format";

import { Skeleton, Autocomplete } from "@material-ui/lab";
import MUIDataTable from "mui-datatables";

import { makeStyles, useTheme } from "@material-ui/styles";
import {
  useItemTypes,
  useOrgRoles,
  useLocations,
  useOperators
} from "../../../hooks/use_hooks";
import {
  FinanceService,
  AdminService,
  Validator,
  Permissions,
} from "../../../../../utils/web_config";

import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  avatar: {
    height: 100,
    width: 100,
    marginTop: -78,
    border: "solid 2px " + theme.palette.background.paper,
  },
}));

function GlobalAgentDetails(props) {
  const classes = useStyles();
  const history = useHistory();
  const Theme = useTheme();

  // const itemTypes = [
  //   {
  //     id: 1251,
  //     name: "POS",
  //     description: "POS used to transact",
  //   },
  //   {
  //     id: 1252,
  //     name: "VALIDATOR",
  //     description: "POS used to transact",
  //   },
  //   {
  //     id: 1254,
  //     name: "KIOSK",
  //     description: "KIOSK for serf services payments",
  //   },
  // ];

  const orgs = useOperators();

  const itemTypes = useItemTypes();

  const locations = useLocations();
  const roles = useOrgRoles({ org_id: history.location.state.organization_id });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [accountData, setAccountData] = useState({});

  const [addNewOpen, setAddNewOpen] = useState(false);
  const [addNewOutletOpen, setAddNewOutletOpen] = useState(false);
  const [addNewAgentOpen, setAddNewAgentOpen] = useState(false);

  const [togglingAgent, setTogglingAgent] = useState(false);
  const [agentEditMode, setAgentEditMode] = useState({
    status: false,
    suspend: false,
  });

  const [hours, setHours] = useState({
    anchor: null,
    selected: {},
    selectedFrom: new Date(),
    selectedTo: new Date(),
    index: "none",
    data: [
      { id: 1, name: "Monday to Friday", from: "24", to: "24" },
      { id: 6, name: "Saturday", from: "24", to: "24" },
      { id: 7, name: "Sunday", from: "08:00", to: "22:00" },
    ],
  });

  const [allOutlets, setAllOutlets] = useState({
    loading: false,
    saving: false,
    status: "Loading agent outlets...",
    data: [],
  });

  const [devices, setDevices] = useState({
    loading: false,
    saving: false,
    status: "Loading agent devices...",
    toggling: false,
    data: [],
    allData: [],
  });

  const [agents, setAgents] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    status: "Loading agent assistants...",
    data: [],
  });

  const [transactions, setStransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    status: "Loading agent transactions",
    data: [],
  });

  const [agentAccount, setAgentAccount] = useState({
    saving: false,
    loading: false,
    data: {},
  });

  const [agentTopup, setAgentTopup] = useState({
    saving: false,
    loading: false,
  });

  const [agentsData, setAgentsData] = useState([]);

  const [agent, setAgent] = useState({});
  const [choice, setChoice] = useState(0);

  const [deviceOutlet, setOutlet] = useState({ value: "", error: "" });
  const [deviceType, setType] = useState({ value: "", error: "" });
  const [deviceSerialNumber, setSerialNumber] = useState({
    value: "",
    error: "",
  });


  /////
  const [outletName, setName] = useState({ value: "", error: "" });
  const [outletLocation, setLocation] = useState({ value: {}, error: "" });

  ////

  const [firstName, setFirstName] = useState({ value: "", error: "" });
  const [lastName, setLastName] = useState({ value: "", error: "" });
  const [email, setEmail] = useState({ value: "", error: "" });
  const [agentUsername, setAgentUsername] = useState({ value: "", error: "" });
  const [phone, setPhone] = useState({ value: "", error: "" });
  const [NID, setNid] = useState({ value: "", error: "" });
  const [gender, setGender] = useState({ value: "", error: "" });

  const [password, setPassword] = useState({ value: "", error: "" });
  const [pin, setPin] = useState({ value: "1234", error: "" });
  const [role, setRole] = useState({ value: "", error: "" });

  ////////////////

  const [topupChannelType, setChannelType] = useState({ value: "", error: "" });
  const [topupReference, setReference] = useState({ value: "", error: "" });
  const [topupAmount, setAmount] = useState({ value: "", error: "" });

  const [warning, setWarning] = useState({ open: false });
  const [anchorAssign, setAnchorAssign] = useState(null);
  const [tempAssign, setTempAssign] = useState({ data: [] });

  const [selectedAgent, setSelectedAgent] = useState({
    saving: false,
    loading: false,
    data: agent,
  });

  const [operators, setOperators] = useState({
    saving: false,
    loadfing: false,
    open:false,
    page: 0,
    pages: 1,
    count: 20,
    per_page: 20,
    data: [],
  });

  const [approver, setApprover] = useState({ value: "", error: "" })

  const [users, setUsers] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    data: [],
  });

  useEffect(() => {

    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    setAgent(history.location.state);

    setAllOutlets({
      ...allOutlets,
      data: history.location.state?.outlets,
      status:
        history.location.state?.outlets?.length == 0
          ? "There are no outlets, create one first"
          : "No outlet found",
    });

    

    // getDevices(accountData.token, history.location.state.agent_code);
    // getOutlets(accountData.token, history.location.state.agent_code);
    // getAssistants(accountData.token, history.location.state.organization_id);
    getTransactions(accountData.token, history.location.state.agent_code);

    getAgentAccount(accountData.token, history.location.state.agent_code);

    getUsers(accountData.token, accountData.organization?.organization_id);
  }, []);
 

  ///////////////////////

  const getUsers = (token, id) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setUsers({ ...users, loading: true });

    usersInstance
      .get(new AdminService().GET_USERS_BY_TYPE + 'ORG_USER?size=10000')
      .then(function (response) {
        console.log(response.data.data)
        setUsers({ ...users, loading: false });

        const d = response.data;
        var usrs = [];

        d.data.forEach((u, i) => {
          const newUser = u;
          newUser["status2"] = u.user_status;
          newUser["user_names"] = u.user_first_name + " " + u.user_last_name;

          usrs.push(u);
        });

        setUsers({
          ...users,
          data: usrs,
        });
      })
      .catch(function (error) {
        setUsers({ ...users, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }


        notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
      });
  };

  ////////////

  const getOperators = (token,id, p = 0) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
    setOperators({ ...operators, loading: true, page: p });

    console.log("getting operators.....");

    usersInstance
      .get(
        new AdminService().GET_ALL_ALLOWED_OPERATORS_BY_GLOBAL_AGENT+
        id+
        "?page=" +
        p +
        "&size=" +
        operators.per_page
      )
      .then(function (response) {
        setOperators({ ...operators, loading: false });

        const d = response.data;

        setOperators({
          ...operators,
          data: d.data,
          page: d.current_page,
          count: d.total_items,
          pages: d.total_pages,
        });
      })
      .catch(function (error) {
        setOperators({ ...operators, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  /////////////

  ////////////////////////

    ////////////////////////////

    const assignOperator = (ogs) => {
      const privInstance = axios.create(
        new AdminService().getHeaders(accountData.token)
      );
  
      setOperators({...operators,loading:true})
  
      console.log("Assigning privilege .....");
      setAnchorAssign(null);
  
      const data = {
        "organization_id": ogs,
        "user_id": selectedAgent.data.user_id
      }
  
      const url = new AdminService().ASSIGN_OPERATORS_TO_GLOBAL_AGENT;
      privInstance
        .post(url, data)
        .then(function (response) {
          setOperators({...operators,loading:false})
  
          const d = response.data;
  
          getOperators(accountData.token, selectedAgent.data.user_id);
         
          notify("success", d.message);
        })
        .catch(function (error) {
          setOperators({...operators,loading:false})
          var e = error.message;
  
          if (error.response) {
            e = error.response.data.message;
          }
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    };


      //////////////////////////
  const removeOperator = () => {
    const roleInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    console.log("Removing.....");

    const url = new AdminService().REMOVE_ONE_GLOBAL_ASSIGNED_OPERATOR_RECORD + warning.allowed;
    roleInstance
      .delete(url)
      .then(function (response) {
        const d = response.data;

        operators.data.splice(warning.index, 1);
        setOperators({...operators});
      
        notify("success", d.message);
      })
      .catch(function (error) {
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////////////////////////
  const toggleAccount = () => {
    const agInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAgentAccount({ ...agentAccount, toggling: true });

    console.log("toggling acc.....");

    const account = agentAccount.data;
    var url;
    if (account.status == "ENABLED") {
      url = new FinanceService().DISABLE_ACCOUNT + account.account_number;
      account["status"] = "DISABLED";
    } else {
      url = new FinanceService().ENABLE_ACCOUNT + account.account_number;
      account["status"] = "ENABLED";
    }

    setAgentAccount({ ...agentAccount, data: account });

    agInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setAgentAccount({
          ...agentAccount,
          data: d.data,
          toggling: false,
        });

        notify("success", d.message);
      })
      .catch(function (error) {
        account["status"] =
          account.status == "ENABLED" ? "DISABLED" : "ENABLED";
        var e = error.message;

        setAgentAccount({
          ...agentAccount,
          data: account,
          toggling: false,
        });

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  /////////////
  const toggleAssistant = (id, j) => {
    const assInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const assist = agentsData.filter((obj) => obj.user_id == id)[0];
    const i = agentsData.indexOf(assist);

    var url =
      assist.user_status == "ENABLED"
        ? new AdminService().DEACTIVATE_USER + id
        : new AdminService().REACTIVATE_USER + id;

    assist["user_status"] =
      assist.user_status == "ENABLED" ? "DISABLED" : "ENABLED";

    console.log("toggling assistant.....");

    setAgents({ ...agents, toggling: true });

    assInstance
      .put(url)
      .then(function (response) {
        const d = response.data;

        agentsData[i] = assist;

        const ass = {
          id: assist.user_id,
          name: assist.user_first_name + " " + assist.user_last_name,
          phone: assist.user_phone,
          gender: assist.user_gender,
          status2: assist.user_status,
          status: capitalize(assist.user_status),
        };

        const ags = agents.data;
        ags[j] = ass;
        setAgents({ ...agents, data: ags, toggling: false });

        notify("success", d.data);
      })
      .catch(function (error) {
        assist["user_status"] =
          assist.user_status == "ENABLED" ? "DISABLED" : "ENABLED";

        agentsData[i] = assist;

        const ass = {
          id: assist.user_id,
          name: assist.user_first_name + " " + assist.user_last_name,
          phone: assist.user_phone,
          gender: assist.user_gender,
          status2: assist.user_status,
          status: capitalize(assist.user_status),
        };

        const ags = agents.data;
        ags[j] = ass;
        setAgents({ ...agents, data: ags, toggling: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  /////////////

  /////////////
  const toggleDevice = (id, j) => {
    const assInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const dev = devices.allData.filter((obj) => obj.id == id)[0];
    const i = devices.allData.indexOf(dev);

    var url =
      dev.status == "ENABLED"
        ? new FinanceService().DISABLE_AGENT_DEVICE + id
        : new FinanceService().ENABLE_AGENT_DEVICE + id;

    dev["status"] = dev.status == "ENABLED" ? "DISABLED" : "ENABLED";

    console.log("toggling device.....");

    setDevices({ ...devices, toggling: true });

    assInstance
      .put(url)
      .then(function (response) {
        const d = response.data;

        devices.allData[i] = d.data;

        const dv = {
          id: dev.id,
          type: dev.device_type,
          serial: dev.serial_number,
          outlet: dev.agent_outlet_id,
          status2: dev.status,
          status: capitalize(dev.status),
        };

        const devs = devices.data;
        devs[j] = dv;

        setDevices({ ...devices, data: devs, toggling: false });

        notify("success", d.message);
      })
      .catch(function (error) {
        dev["status"] = dev.status == "ENABLED" ? "DISABLED" : "ENABLED";

        devices.allData[i] = dev;

        const dv = {
          id: dev.id,
          type: dev.device_type,
          serial: dev.serial_number,
          outlet: dev.agent_outlet_id,
          status2: dev.status,
          status: capitalize(dev.status),
        };

        const devs = devices.data;
        devs[j] = dv;
        setDevices({ ...devices, data: devs, toggling: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ////////////////////////////

  const toggleAgent = () => {
    const agInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setTogglingAgent(true);

    console.log("toggling agent.....");

    var url;
    if (agent.user_status == "ENABLED") {
      url = new AdminService().DEACTIVATE_ORGANIZATION + agent.organization_id;
      agent["status"] = "DISABLED";
    } else {
      url = new AdminService().REACTIVATE_ORGANIZATION + agent.organization_id;
      agent["status"] = "ENABLED";
    }

    agInstance
      .put(url)
      .then(function (response) {
        const d = response.data;
        setTogglingAgent(false);

        notify("success", d.data);
      })
      .catch(function (error) {
        setTogglingAgent(false);
        agent["status"] =
          agent.user_status == "ENABLED" ? "DISABLED" : "ENABLED";
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////
  const showAssistEdit = (id) => {
    setAddNewAgentOpen(true);
    setAgentEditMode({ ...agentEditMode, status: true, id: id });

    const assist = agentsData.filter((obj) => obj.user_id == id)[0];
    const i = agentsData.indexOf(assist);

    setFirstName({ ...firstName, value: assist.user_first_name });
    setLastName({ ...lastName, value: assist.user_last_name });
    setEmail({ ...email, value: assist.user_email });
    setGender({ ...gender, value: assist.user_gender });
    setPhone({ ...phone, value: assist.user_phone });
    setNid({ ...lastName, value: assist.user_nid });
  };

  const updateAssistant = (data) => {
    const updateInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAgents({ ...agents, saving: true });

    console.log("Updating agent .....");

    updateInstance
      .put(new AdminService().UPDATE_USER + agentEditMode.id, data)
      .then(function (response) {
        setAgents({ ...agents, saving: false });
        var d = response.data;
        agentsData.push(d.data);

        var usrs = agents.data;

        const assist = agentsData.filter(
          (obj) => obj.user_id == agentEditMode.id
        )[0];
        const i = agentsData.indexOf(assist);

        const assist2 = agents.data.filter(
          (obj) => obj.id == agentEditMode.id
        )[0];

        const j = agents.data.indexOf(assist2);

        usrs[j] = {
          id: d.data.user_id,
          name: d.data.user_first_name + " " + d.data.user_last_name,
          phone: d.data.user_phone,
          gender: d.data.user_gender,
          status2: d.data.user_status,
          status: capitalize(d.data.user_status),
        };

        agentsData[i] = d.data;

        setAgents({
          ...agents,
          data: usrs,
        });

        clearagentInfo();
        notify("success", response.data.message);

        setAgentEditMode({ status: false });
        setAddNewAgentOpen(false);
      })
      .catch(function (error) {
        setAgents({ ...agents, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        console.log(error);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const getAgentAccount = (token, code) => {
    const agentsInstance = axios.create(new AdminService().getHeaders(token));

    setAgentAccount({ ...agentAccount, loading: true });

    console.log("getting account .....");

    agentsInstance
      .get(new FinanceService().GET_AGENT_PROFILE + code)
      .then(function (response) {
        const d = response.data;

        setAgentAccount({
          ...agentAccount,
          loading: false,
          data: d.data.account,
        });
      })
      .catch(function (error) {
        setAgentAccount({ ...agentAccount, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////
  const agentsColums = [
    {
      name: "id",
      label: "User id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "name",
      label: "Agent name",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "gender",
      label: "Gender",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {agents.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                agents.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={agents.data[dataI].status}
            />
          );
        },
      },
    },
  ];

  //////////
  const transactionsColums = [
    {
      name: "tx_type_name",
      label: "Transaction type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "channel_type",
      label: "Channel",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "credited_account",
      label: "Account",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "total_commission_amount",
      label: "Commission",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "tx_date",
      label: "Date",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tx_time",
      label: "Time",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "mine",
      label: "Dr/Cr",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <>
              {transactions.data[dataI].debited_account ==
              agentAccount.data.account_number ? (
                <CallMade color="inherit" />
              ) : (
                <CallReceived color="primary" />
              )}
            </>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {["completed", "confirmed"].includes(
                    transactions.data[dataI].status.toLowerCase()
                  ) ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                transactions.data[dataI].status.toLowerCase() == "completed"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transactions.data[dataI].status)}
            />
          );
        },
      },
    },
  ];

  //////

  const columns = [
    {
      name: "id",
      label: "Device id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "type",
      label: "Device type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "serial",
      label: "Serial number",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "outlet",
      label: "Outlet",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {devices.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                devices.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={devices.data[dataI].status}
            />
          );
        },
      },
    },
  ];

  //////

  const outletColumns = [
    {
      name: "name",
      label: "Outlet name",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "code",
      label: "Outlet code",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "location_id",
      label: "Location",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "working_hours_id",
      label: "Working hours",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {allOutlets.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                allOutlets.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={allOutlets.data[dataI].status}
            />
          );
        },
      },
    },
  ];

  ///////////

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search transaction...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      var tr = transactions.data[cellMeta.dataIndex];
      history.push("/centrika/agents/details/viewTransaction", tr);
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
  };

  const agentsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search agent...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: agents.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomAgentsToolbar
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        toggleAssistant={toggleAssistant}
        openEdit={showAssistEdit}
        toggling={agents.toggling}
      />
    ),
  };

  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search device...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    print: false,
    download: false,
    viewColumns: false,
    // setTableProps: () => {
    //   return {
    //     padding: "none",
    //     // material ui v4 only
    //     size: "small",
    //   };
    // },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: devices.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomDevicesToolbar
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        toggleDevice={toggleDevice}
        toggling={devices.toggling}
      />
    ),
  };

  const outletOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search outlet...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    print: false,
    download: false,
    viewColumns: false,
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: allOutlets.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <>
        {/* <CustomDevicesToolbar
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          toggleDevice={toggleDevice}
          toggling={outlets.toggling}
        /> */}
      </>
    ),
  };
  ////////////////////////////

  const onApproverChange = (event) => {
    if (event.target.value === "") {
      setApprover({
        value: "",
        error: "Please Choose Approver",
      });
    } else {
      setApprover({ value: event.target.value, error: "" });
    }
  };

  const onChannelTypeChange = (event) => {
    if (event.target.value === "") {
      setChannelType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_channel_type")
            }
          </Translate>
        ),
      });
    } else {
      setChannelType({ value: event.target.value, error: "" });
    }
  };
  const onReferenceChange = (event) => {
    if (event.target.value === "") {
      setReference({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_reference")
            }
          </Translate>
        ),
      });
    } else {
      setReference({ value: event.target.value, error: "" });
    }
  };
  const onAmountChange = (event) => {
    if (event.target.value === "") {
      setAmount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_amount")
            }
          </Translate>
        ),
      });
    } else {
      setAmount({ value: event.target.value, error: "" });
    }
  };
  ///////////////////

  const onFirstNameChange = (event) => {
    if (event.target.value === "") {
      setFirstName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_first_name")
            }
          </Translate>
        ),
      });
    } else {
      setFirstName({ value: event.target.value, error: "" });
    }
  };
  const onLastNameChange = (event) => {
    if (event.target.value === "") {
      setLastName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_last_name")}
          </Translate>
        ),
      });
    } else {
      setLastName({ value: event.target.value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_email")}
          </Translate>
        ),
      });
    } else {
      setEmail({ value: event.target.value, error: "" });
    }
  };
  const onAgentUsernameChange = (event) => {
    if (event.target.value === "") {
      setAgentUsername({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_username")}
          </Translate>
        ),
      });
    } else {
      setAgentUsername({ value: event.target.value, error: "" });
    }
  };
  const onPhoneChange = (event) => {
    if (event.target.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_phone")}
          </Translate>
        ),
      });
    } else {
      setPhone({ value: event.target.value, error: "" });
    }
  };
  const onNidChange = (event) => {
    if (event.target.value === "") {
      setNid({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_nid")}
          </Translate>
        ),
      });
    } else {
      setNid({ value: event.target.value, error: "" });
    }
  };
  const onGenderChange = (event) => {
    if (event.target.value === "") {
      setGender({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_gender")}
          </Translate>
        ),
      });
    } else {
      setGender({ value: event.target.value, error: "" });
    }
  };

  const onPasswordChange = (event) => {
    if (event.target.value === "") {
      setPassword({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_password")}
          </Translate>
        ),
      });
    } else {
      setPassword({ value: event.target.value, error: "" });
    }
  };

  const onPinChange = (event) => {
    if (event.target.value === "") {
      setPin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_pin")}
          </Translate>
        ),
      });
    } else {
      setPin({ value: event.target.value, error: "" });
    }
  };

  const onRoleChange = (event) => {
    if (event.target.value === "") {
      setRole({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_role")}
          </Translate>
        ),
      });
    } else {
      setRole({ value: event.target.value, error: "" });
    }
  };

  const onRegisterAgentClick = () => {
    if (firstName.value === "") {
      setFirstName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agents.forms.hints.agent_first_name")
            }
          </Translate>
        ),
      });
    } else if (new Validator().tooShort(firstName.value)) {
      setFirstName({
        value: firstName.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_first_name_short")
            }
          </Translate>
        ),
      });
    } else if (lastName.value === "") {
      setLastName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_last_name")}
          </Translate>
        ),
      });
    } else if (new Validator().tooShort(lastName.value)) {
      setLastName({
        value: lastName.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_last_name_short")
            }
          </Translate>
        ),
      });
    }
    // else if (email.value === "") {
    //   setEmail({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) => translate("agents.forms.hints.agent_email")}
    //       </Translate>
    //     ),
    //   });
    // }
    else if (email.value != "" && !new Validator().validEmail(email.value)) {
      setEmail({
        value: email.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_email_invalid")
            }
          </Translate>
        ),
      });
    } else if (agentUsername.value === "" && !agentEditMode.status) {
      setAgentUsername({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_username")}
          </Translate>
        ),
      });
    } else if (
      new Validator().tooShort(agentUsername.value) &&
      !agentEditMode.status
    ) {
      setAgentUsername({
        value: agentUsername.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_username_short")
            }
          </Translate>
        ),
      });
    } else if (
      !new Validator().validUsername(agentUsername.value) &&
      !agentEditMode.status
    ) {
      setAgentUsername({
        value: agentUsername.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_username_invalid")
            }
          </Translate>
        ),
      });
    } else if (phone.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_phone")}
          </Translate>
        ),
      });
    } else if (NID.value === "") {
      setNid({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_nid")}
          </Translate>
        ),
      });
    } else if (gender.value === "") {
      setGender({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_gender")}
          </Translate>
        ),
      });
    } else if (password.value === "" && !agentEditMode.status) {
      setPassword({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_password")}
          </Translate>
        ),
      });
    } else if (role.value === "") {
      setRole({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("agents.forms.hints.agent_role")}
          </Translate>
        ),
      });
    }
    // else if (pin.value === "") {
    //   setPin({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) => translate("agents.forms.hints.agent_pin")}
    //       </Translate>
    //     ),
    //   });
    // }
    else {
      createagent();
    }
  };

  //////////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.outlet_name")
            }
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onLocationChange = (event, v) => {
    if (v?.id == null) {
      setLocation({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.outlet_location")
            }
          </Translate>
        ),
      });
    } else {
      setLocation({ value: v, error: "" });
    }
  };

  const onCreateOutletClick = () => {
    if (outletName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.outlet_name")
            }
          </Translate>
        ),
      });
    } else if (outletLocation.value?.id == null) {
      setLocation({
        value: {},
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.outlet_location")
            }
          </Translate>
        ),
      });
    } else {
      createOutlet();
    }
  };
  ////////

  const onOutletChange = (event) => {
    if (event.target.value === "") {
      setOutlet({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_outlet")
            }
          </Translate>
        ),
      });
    } else {
      setOutlet({ value: event.target.value, error: "" });
    }
  };
  const onTypeChange = (event) => {
    if (event.target.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_type")
            }
          </Translate>
        ),
      });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };
  const onSerialNumberChange = (event) => {
    if (event.target.value === "") {
      setSerialNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_serial_number")
            }
          </Translate>
        ),
      });
    } else {
      setSerialNumber({ value: event.target.value, error: "" });
    }
  };
  ////////////////////

  const onTopupClick = () => {
    if (topupChannelType.value === "") {
      setChannelType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_channel_type")
            }
          </Translate>
        ),
      });
    } 
    else if (approver.value === "") {
      setApprover({
        value: "",
        error: "Please choose approver",
      });
    } 
    else if (topupReference.value === "") {
      setReference({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_reference")
            }
          </Translate>
        ),
      });
    } else if (topupAmount.value === "") {
      setAmount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.topup_amount")
            }
          </Translate>
        ),
      });
    } else {
      doTopup();
    }
  };
  //////////////////

  const onCreateDeviceClick = () => {
    if (deviceOutlet.value === "") {
      setOutlet({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_outlet")
            }
          </Translate>
        ),
      });
    } else if (deviceType.value === "") {
      setType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_type")
            }
          </Translate>
        ),
      });
    } else if (deviceSerialNumber.value === "") {
      setSerialNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("agent_details.forms.hints.device_serial_number")
            }
          </Translate>
        ),
      });
    } else {
      createDevice();
    }
  };
  ////////////////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  ///////////////////////////////////

  const getDevices = (token, code) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setDevices({ ...devices, loading: true });

    console.log("getting devices .....");

    usersInstance
      .get(new FinanceService().GET_AGENT_DEVICES + code)
      .then(function (response) {
        setDevices({ ...devices, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setDevices({ ...devices, status: "There are no devices available" });
        } else {
          var dvs = [];

          d.data.forEach((dv, i) => {
            dvs.push({
              id: dv.id,
              type: dv.device_type,
              serial: dv.serial_number,
              outlet: dv.agent_outlet_id,
              status2: dv.status,
              status: capitalize(dv.status),
            });
          });

          setDevices({ ...devices, data: dvs, allData: d.data });
        }
      })
      .catch(function (error) {
        setDevices({ ...devices, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setDevices({ ...devices, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ///////////////////////////////////

  const getOutlets = (token, code) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setAllOutlets({ ...allOutlets, loading: true });

    console.log("getting outlets.....");

    usersInstance
      .get(new FinanceService().GET_AGENT_OUTLETS + code)
      .then(function (response) {
        setAllOutlets({ ...allOutlets, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setAllOutlets({
            ...allOutlets,
            status: "There are no outlets available",
          });
        } else {
          var dvs = [];

          setAllOutlets({ ...devices, data: d.data, allData: d.data });
        }
      })
      .catch(function (error) {
        setAllOutlets({ ...allOutlets, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setAllOutlets({ ...allOutlets, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ///////////////////////////////////

  const getTransactions = (token, code) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setStransactions({ ...transactions, loading: true });

    console.log("getting transactions .....");

    usersInstance
      .get(new FinanceService().GET_AGENT_TRANSACTIONS + code + "?per_page=500")
      .then(function (response) {
        setStransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setStransactions({
            ...transactions,
            status: "There are no transactions available",
          });
        } else {
          var groups = new Validator().groupArrayOfObjects(
            d.data,
            "tx_type_name"
          );
          var keys = Object.keys(groups);
          setStransactions({
            ...transactions,
            data: d.data,
            allData: d.data,
            keys: keys,
            groups: groups,
          });
        }
      })
      .catch(function (error) {
        setStransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ////////////////

  const clearagentInfo = () => {
    setRole({ value: "", error: "" });
    setEmail({ value: "", error: "" });
    setFirstName({ value: "", error: "" });
    setLastName({ value: "", error: "" });
    setAgentUsername({ value: "", error: "" });
    setNid({ value: "", error: "" });
    setPassword({ value: "", error: "" });
    setPhone({ value: "", error: "" });
  };
  /////////////////////

  const createagent = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setAgents({ ...agents, saving: true });

    const data = {
      organization_id: agent.organization_id,
      role_id: role.value,
      user_email: email.value,
      user_first_name: firstName.value,
      user_gender: gender.value,
      user_last_name: lastName.value,
      user_name: agentUsername.value,
      user_nid: NID.value,
      user_password: password.value,
      user_phone: phone.value,
      user_pin: pin.value,
      user_type: "AGENT",
    };

    if (agentEditMode.status) {
      updateAssistant(data);
      return;
    }

    console.log("Creating agent .....");

    createInstance
      .post(new AdminService().CREATE_USER, data)
      .then(function (response) {
        setAgents({ ...agents, saving: false });
        var d = response.data;
        agentsData.push(d.data);

        var usrs = agents.data;
        usrs.unshift({
          id: d.data.user_id,
          name: d.data.user_first_name + " " + d.data.user_last_name,
          phone: d.data.user_phone,
          gender: d.data.user_gender,
          status2: d.data.user_status,
          status: capitalize(d.data.user_status),
        });

        setAgents({
          ...agents,
          data: usrs,
        });
        agentsData.push(d.data);

        clearagentInfo();
        notify("success", response.data.message);

        setAddNewAgentOpen(false);
      })
      .catch(function (error) {
        setAgents({ ...agents, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        console.log(error);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const getAssistants = (token, org_id) => {
    const agentsInstance = axios.create(new AdminService().getHeaders(token));

    setAgents({ ...agents, loading: true });

    console.log("getting assistants .....");

    agentsInstance
      .get(new AdminService().GET_AGENT_ASSISTANTS + org_id)
      .then(function (response) {
        setAgents({ ...agents, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setAgents({ ...agents, status: "There are no agents available." });
        } else {
          setAgentsData(d.data);
          var usrs = [];

          d.data.forEach((u, i) => {
            usrs.push({
              id: u.user_id,
              name: u.user_first_name + " " + u.user_last_name,
              phone: u.user_phone,
              gender: u.user_gender,
              status2: u.user_status,
              status: capitalize(u.user_status),
            });
          });

          setAgents({
            ...agents,
            data: usrs,
          });
        }
      })
      .catch(function (error) {
        setAgents({ ...agents, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setAgents({ ...agents, status: e });

        //notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////

  const createDevice = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setDevices({ ...devices, saving: true });

    const data = {
      code: agent.agent_code,
      outlet_code: deviceOutlet.value,
      device_type: deviceType.value,
      serial_number: deviceSerialNumber.value,
    };

    console.log("Creating device .....");

    createInstance
      .post(new FinanceService().CREATE_AGENT_DEVICE, data)
      .then(function (response) {
        setDevices({ ...devices, saving: false });
        var d = response.data;

        var dvs = devices.data;
        var dv = d.data;

        dvs.unshift({
          id: dv.id,
          type: dv.device_type,
          serial: dv.serial_number,
          outlet: dv.agent_outlet_id,
          status2: dv.status,
          status: capitalize(dv.status),
        });
        const allD = devices.allData;
        allD.unshift(d.data);

        setDevices({ ...devices, data: dvs, allData: allD });

        notify("success", response.data.message);
        setAddNewOpen(false);
      })
      .catch(function (error) {
        setDevices({ ...devices, saving: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  //////////////////////////////

  const createOutlet = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setAllOutlets({ ...allOutlets, saving: true });

    const data = {
      code: agent.agent_code,
      agent_outlet: agent.agent_code,
      name: outletName.value,
      location_id: outletLocation.value.id,
      working_hours: {
        monday_friday_from: hours.data[0].from,
        monday_friday_to: hours.data[0].to,
        saturday_from: hours.data[1].from,
        saturday_to: hours.data[1].to,
        sunday_from: hours.data[2].from,
        sunday_to: hours.data[2].to,
      },
    };

    console.log("Creating outlet.....");

    createInstance
      .post(new FinanceService().CREATE_AGENT_OUTLET, data)
      .then(function (response) {
        setAllOutlets({ ...allOutlets, saving: false });
        var d = response.data;

        var outs = allOutlets.data;
        outs.unshift(d.data);
        setAllOutlets({ ...allOutlets, data: outs });

        notify("success", response.data.message);

        setAddNewOutletOpen(false);
      })
      .catch(function (error) {
        setAllOutlets({ ...allOutlets, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  //////////////////

  const doTopup = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setAgentTopup({ ...agentTopup, saving: true });

    const data = {
      channel_type: topupChannelType.value,
      agent_code: agent.agent_code,
      external_reference_number: topupReference.value,
      amount: topupAmount.value,
      request_type: "AGENT_TOPUP",
      approver: approver.value
    };

    console.log("Topup .....");

    createInstance
      .post(new FinanceService().REQUEST_AGENT_TOPUP_TRANSACTION, data)
      .then(function (response) {
        var d = response.data;
        var ts = transactions.data;
        ts.unshift(d.data);

        setStransactions({ ...transactions, data: ts });

        setAgentTopup({ ...agentTopup, saving: false, open: false });
        notify("success", "Request sent successfull");
        getAgentAccount(accountData.token, agent.agent_code);
      })
      .catch(function (error) {
        setAgentTopup({ ...agentTopup, saving: false });
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
       
       {/* Dialogs starts here */}
      <Dialog
        open={warning.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to remove this operator from this global agent, he won't transact for this operator anymore.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWarning({ ...warning, open: false });
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              removeOperator();
              setWarning({ ...warning, open: false });
            }}
            color="primary"
            autoFocus
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
      {/* /////////////////// */}
      <Popover
        id={"pop-id-2"}
        style={{minWidth:200}}
        open={anchorAssign != null}
        anchorEl={anchorAssign}
        onClose={() => {
          setAnchorAssign(null);
          setTempAssign({ data: [] });
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={4}
      >

        {tempAssign.data.length != 0 && (
          <Box
            display="flex"
            justifyContent="center"
            p={2}
            mb={4}
            width={"250px"}
            style={{ position: "fixed", zIndex: 100, bottom: 0 }}
          >
            <Button
              color="primary"
              size="large"
              variant="contained"
              onClick={() => assignOperator(tempAssign.data)}
            >
              Assign all {"(" + tempAssign.data.length + ")"}
            </Button>
          </Box>
        )}

        <List>
          <ListItem key="987hh">
            <ListItemIcon>
              <Checkbox
              disabled={orgs?.data==null}
                color="primary"
                checked={tempAssign.all}
                onChange={(e) => {
                  var d = tempAssign.data;

                  if (e.target.checked) {
                    orgs.data.forEach((o, i) => {
                      d.push(o.organization_id);
                    });

                    setTempAssign({
                      data: d,
                      all: true,
                    });
                  } else {
                    setTempAssign({
                      ...tempAssign,
                      data: [],
                      all: false,
                    });
                  }
                }}
              />
            </ListItemIcon>
            <ListItemText primary="Select all" />
          </ListItem>
          {orgs?.data!=null!=null
            ? orgs?.data?.map((org, i) => (
              <>
                {i != 0 && i != orgs?.data.length && (
                  <Divider variant="middle" />
                )}
                <ListItem
                  key={i}
                  dense
                  selected={tempAssign.data.includes(org.organization_id)}
                >
                  <ListItemIcon>
                    <Checkbox
                      color="primary"
                      checked={tempAssign.data.includes(org.organization_id)}
                      onChange={(e) => {
                        var d = tempAssign.data;

                        if (e.target.checked) {
                          d.push(org.organization_id);
                          setTempAssign({
                            
                            data: d,
                          });
                        } else {
                          const i2 = d.indexOf(org.organization_id);

                          d.splice(i2, 1);
                          setTempAssign({
                            ...tempAssign,
                            data: d,
                          });
                        }
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={org.name}
                    secondary={org.organization_type}
                  />
                </ListItem>
              </>
            ))
            :  <Box
              p={2}
              mt={3}
              mb={3}
              height={1}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Box mt={2}>
                <img src={Empty} alt="Empty data" height={200} />
              </Box>
              <Typography color="textSecondary">
                There are no operators at the moment.
                </Typography>
            </Box>}
        </List>
      </Popover>
    {/* //////////////////////// */}
 {/* ////////////////////////// */}

 <Dialog
        open={selectedAgent.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setSelectedAgent({ ...selectedAgent, open: false })}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedAgent.data.user_first_name +
            " " +
            selectedAgent.data.user_last_name}{" "}
          
        </DialogTitle>
        <DialogContent>
          
              <Box display="flex" justifyContent="center" mt={2}>
                <Button color='primary' variant='outlined' onClick={(e)=>setAnchorAssign(e.currentTarget)}> Assign operators</Button>
              </Box>
              {!operators.loading && operators.data.length == 0 && <Box
              p={2}
              mt={3}
              height={1}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Box mt={2}>
                <img src={Empty} alt="Empty data" height={100} />
              </Box>
              <Typography color="textSecondary">
                There are no assigned oparators to this agent at the moment.
                </Typography>
            </Box>}
           <Box p={2}> <Typography gutterBottom>
                List of assigned operators to this agent.
                </Typography>
                </Box>
            <List>
              {!operators.loading
                ? operators.data.map((op, i) => (
                  <ListItem
                    key={i}
                    button
                    // selected={selectedRole.index == i}
                    // onClick={() => {
                    //   setSelectedRole({ index: i, role: role });
                    //   getPrivileges(accountData.token, role.role_id);
                    // }}
                  >
                    <ListItemIcon>
                      <BusinessCenter />
                    </ListItemIcon>
                    <ListItemText primary={op.organization.name} />
                    <ListItemSecondaryAction>
                              <IconButton
                                  onClick={(e) =>
                                    setWarning({
                                      op: op,
                                      allowed: op.user_allowed_operator_id,
                                      open: true,
                                      index: i,
                                    })
                                 }
                                  size="small"
                                >
                                  <Delete fontSize="small" />
                                </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
                : [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                 
                ].map((item, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>
                      <Skeleton variant="circle" width={20} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Skeleton
                          variant="text"
                          width={"100%"}
                          style={{ borderRadius: 7 }}
                        />
                      }
                    />
                  </ListItem>
                ))}
            </List>

        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSelectedAgent({ ...selectedAgent, open: false });
            }}
            color="primary"
          >
            Close dialog
          </Button>
        </DialogActions>
      </Dialog>
        {/* //////////////////////// */}

        <Dialog
          open={agentTopup.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => setAgentTopup({ ...agentTopup, open: false })}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">{"Request Agent topup"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Top up agent account here
            </DialogContentText>


            <Box mt={2}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                error={approver.error !== ""}
              >
                <InputLabel>
                  Approver
                </InputLabel>
                <Select
                  label={"Choose Approver"}
                  value={approver.value}
                  onChange={onApproverChange}
                >
                  {users.data.filter(o => process.env.REACT_APP_APPROVERS.includes(o.user_name)).map((c, i) => (
                    <MenuItem value={c.user_id}>{c.user_names}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{approver.error}</FormHelperText>
              </FormControl>
            </Box>

            <Box mt={2}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                error={topupChannelType.error !== ""}
              >
                <InputLabel>
                  <Translate id="agent_details.forms.labels.topup_channel_type" />
                </InputLabel>
                <Select
                  label={
                    <Translate id="agent_details.forms.labels.topup_channel_type" />
                  }
                  value={topupChannelType.value}
                  onChange={onChannelTypeChange}
                >
                  {["WEB", "POS", "APP"].map((c, i) => (
                    <MenuItem value={c}>{c}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{topupChannelType.error}</FormHelperText>
              </FormControl>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={topupReference.value}
                    placeholder={translate(
                      "agent_details.forms.hints.topup_reference"
                    )}
                    label={
                      <Translate id="agent_details.forms.labels.topup_reference" />
                    }
                    fullWidth
                    onChange={onReferenceChange}
                    helperText={topupReference.error}
                    error={topupReference.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={topupAmount.value}
                    placeholder={translate(
                      "agent_details.forms.hints.topup_amount"
                    )}
                    label={
                      <Translate id="agent_details.forms.labels.topup_amount" />
                    }
                    fullWidth
                    onChange={onAmountChange}
                    helperText={topupAmount.error}
                    error={topupAmount.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setAgentTopup({ ...agentTopup, open: false })}
              color="primary"
            >
              <Translate id="agent_details.forms.buttons.cancel" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onTopupClick}
              autoFocus
              disableElevation
              disabled={agentTopup.saving}
            >
              {agentTopup.saving ? <CircularProgress size={25} /> : "Request"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={addNewOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => setAddNewOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">
            {" "}
            <Translate id="agent_details.forms.dialog_title" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Translate id="agent_details.forms.dialog_desc" />
            </DialogContentText>
            <Box>
              <Box mt={2}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  error={
                    deviceOutlet.error !== "" || allOutlets.data?.length == 0
                  }
                  disabled={
                    roles.status == "error" || allOutlets.data?.length == 0
                  }
                >
                  <InputLabel>
                    <Translate id="agent_details.forms.labels.device_outlet" />
                  </InputLabel>
                  <Select
                    label={
                      <Translate id="agent_details.forms.labels.device_outlet" />
                    }
                    value={deviceOutlet.value}
                    onChange={onOutletChange}
                  >
                    {allOutlets.data?.map((out, i) => (
                      <MenuItem value={out.code}>{out.name}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {allOutlets.data?.length == 0
                      ? "There is no outlet available for this agent, create one first"
                      : deviceOutlet.error}
                  </FormHelperText>
                </FormControl>
              </Box>
              <Box mt={2}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  size="small"
                  error={deviceType.error !== "" || itemTypes.status == "error"}
                >
                  <InputLabel>
                    <Translate id="agent_details.forms.labels.device_type" />
                  </InputLabel>
                  <Select
                    label={
                      <Translate id="agent_details.forms.labels.device_type" />
                    }
                    value={deviceType.value}
                    onChange={onTypeChange}
                  >
                    {itemTypes.data?.map((item, i) => (
                      <MenuItem value={item.name}>{item.name}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {itemTypes.status == "error"
                      ? "Error loading item types, try reloading the page."
                      : deviceType.error}
                  </FormHelperText>
                </FormControl>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={deviceSerialNumber.value}
                      placeholder={translate(
                        "agent_details.forms.hints.device_serial_number"
                      )}
                      label={
                        <Translate id="agent_details.forms.labels.device_serial_number" />
                      }
                      fullWidth
                      onChange={onSerialNumberChange}
                      helperText={deviceSerialNumber.error}
                      error={deviceSerialNumber.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setAddNewOpen(false)}
              color="primary"
            >
              <Translate id="agent_details.forms.buttons.cancel" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onCreateDeviceClick}
              autoFocus
              disableElevation
              disabled={devices.saving}
            >
              {devices.saving ? (
                <CircularProgress size={25} />
              ) : (
                <Translate id="agent_details.forms.buttons.create" />
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* //////////////////////////////////////// */}

        <Dialog
          open={addNewOutletOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => setAddNewOutletOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">{"New outlet"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Create new outlet for this agent
            </DialogContentText>
            <Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      type="text"
                      value={outletName.value}
                      placeholder={translate(
                        "agent_details.forms.hints.outlet_name"
                      )}
                      label={
                        <Translate id="agent_details.forms.labels.outlet_name" />
                      }
                      fullWidth
                      onChange={onNameChange}
                      helperText={outletName.error}
                      error={outletName.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Autocomplete
                  fullWidth
                  openOnFocus
                  options={locations}
                  getOptionLabel={(option) => option.name}
                  onChange={onLocationChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label={
                        <Translate id="agent_details.forms.labels.outlet_location" />
                      }
                      variant="outlined"
                      size="small"
                      helperText={outletLocation.error}
                      error={outletLocation.error !== ""}
                    />
                  )}
                />
              </Box>
            </Box>

            <Box>
              <Box mt={2}>
                <Typography mt={2}>Working hours</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Box
                  m={2}
                  p={2}
                  border={1}
                  borderRadius="borderRadius"
                  borderColor="action.main"
                  flexGrow={1}
                >
                  {hours.data.map((h, i) => (
                    <Box
                      p={"5px"}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography>{h.name}</Typography>
                      <Box display="flex" alignItems="center">
                        <Typography color="textSecondary">
                          {h.from == "Closed"
                            ? "Closed"
                            : h.from == "24"
                            ? "24 hours"
                            : h.from + " -" + h.to}
                        </Typography>
                        <Box ml={1}>
                          {" "}
                          <IconButton
                            size="small"
                            onClick={(e) =>
                              setHours({
                                ...hours,
                                anchor: e.currentTarget,
                                index: i,
                                selected: h,
                              })
                            }
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Box></Box>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => setAddNewOutletOpen(false)}
              color="primary"
            >
              <Translate id="agent_details.forms.buttons.cancel" />
            </Button>
            <Button
              variant="contained"
              onClick={onCreateOutletClick}
              color="primary"
              autoFocus
              disableElevation
              disabled={allOutlets.saving}
            >
              {allOutlets.saving ? (
                <CircularProgress size={25} />
              ) : (
                <Translate id="agent_details.forms.buttons.create" />
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ////////////////////// */}

        <Popover
          id={"pop-id"}
          open={hours.anchor != null}
          anchorEl={hours.anchor}
          onClose={() => setHours({ ...hours, anchor: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography>Edit working hours</Typography>
            <Box m={2}>
              <FormControlLabel
                control={
                  <Switch
                    value={hours.selected.from}
                    checked={hours.selected?.from == "24"}
                    onChange={(e) => {
                      var h = hours.data[hours.index];

                      h["from"] =
                        e.target.value == "24"
                          ? Format(hours.selectedFrom, ["HH:mm"])
                          : "24";

                      h["to"] =
                        e.target.value == "24"
                          ? Format(hours.selectedTo, ["HH:mm"])
                          : "24";

                      var hh = hours.data;
                      hh[hours.index] = h;
                      setHours({ ...hours, data: hh });
                    }}
                    color="primary"
                  />
                }
                label={"24 hours"}
              />

              <FormControlLabel
                control={
                  <Switch
                    value={hours.selected.from}
                    checked={hours.selected?.from == "Closed"}
                    onChange={(e) => {
                      var h = hours.data[hours.index];

                      h["from"] =
                        e.target.value == "Closed"
                          ? Format(hours.selectedFrom, ["HH:mm"])
                          : "Closed";

                      h["to"] =
                        e.target.value == "Closed"
                          ? Format(hours.selectedTo, ["HH:mm"])
                          : "Closed";

                      var hh = hours.data;
                      hh[hours.index] = h;
                      setHours({ ...hours, data: hh });
                    }}
                    color="primary"
                  />
                }
                label={"Closed"}
              />

              <Box display="flex" alignItems="center">
                <TimePicker
                  ampm={false}
                  disableToolbar
                  autoOk
                  variant="inline"
                  label="From time"
                  value={hours.selectedFrom}
                  onChange={(d) => {
                    var h = hours.data[hours.index];
                    h["from"] = Format(d, ["HH:mm"]);
                    h["to"] = Format(hours.selectedTo, ["HH:mm"]);

                    var hh = hours.data;
                    hh[hours.index] = h;

                    setHours({ ...hours, selectedFrom: d, data: hh });
                  }}
                />
                <Box mr={1} ml={1} flexGrow={1}>
                  <Typography>To</Typography>
                </Box>
                <TimePicker
                  ampm={false}
                  disableToolbar
                  autoOk
                  variant="inline"
                  label="To time"
                  value={hours.selectedTo}
                  onChange={(d) => {
                    var h = hours.data[hours.index];
                    h["to"] = Format(d, ["HH:mm"]);
                    h["from"] = Format(hours.selectedFrom, ["HH:mm"]);

                    var hh = hours.data;
                    hh[hours.index] = h;

                    setHours({ ...hours, selectedTo: d, data: hh });
                  }}
                />
              </Box>
            </Box>
            <Button
              onClick={() => {
                setHours({
                  ...hours,
                  anchor: null,
                  index: "none",
                  selected: {},
                });
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (
                  hours.selected?.from == "Closed" ||
                  hours.selected?.from == "24"
                ) {
                  setHours({
                    ...hours,
                    anchor: null,
                    index: "none",
                    selected: {},
                  });
                  return;
                }
                var h = hours.data[hours.index];

                h["from"] = Format(hours.selectedFrom, ["HH:mm"]);
                h["to"] = Format(hours.selectedTo, ["HH:mm"]);

                var hh = hours.data;
                hh[hours.index] = h;
                setHours({ ...hours, data: hh });

                setHours({
                  ...hours,
                  anchor: null,
                  index: "none",
                  selected: {},
                });
              }}
              color="primary"
              autoFocus
            >
              Apply
            </Button>
          </Box>
        </Popover>

        {/* //////////////////////////////////// */}

        <Dialog
          open={addNewAgentOpen}
          maxWidth="sm"
          fullWidth
          onClose={() => setAddNewAgentOpen(false)}
        >
          <DialogTitle id="new-op">Add new agent assistant</DialogTitle>
          <DialogContent>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={firstName.value}
                    placeholder={translate(
                      "agents.forms.hints.agent_first_name"
                    )}
                    label={
                      <Translate id="agents.forms.labels.agent_first_name" />
                    }
                    fullWidth
                    onChange={onFirstNameChange}
                    helperText={firstName.error}
                    error={firstName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={lastName.value}
                    placeholder={translate(
                      "agents.forms.hints.agent_last_name"
                    )}
                    label={
                      <Translate id="agents.forms.labels.agent_last_name" />
                    }
                    fullWidth
                    onChange={onLastNameChange}
                    helperText={lastName.error}
                    error={lastName.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={email.value}
                    placeholder={translate("agents.forms.hints.agent_email")}
                    label={<Translate id="agents.forms.labels.agent_email" />}
                    fullWidth
                    onChange={onEmailChange}
                    helperText={email.error}
                    error={email.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={agentUsername.value}
                    placeholder={translate("agents.forms.hints.agent_username")}
                    label={
                      <Translate id="agents.forms.labels.agent_username" />
                    }
                    fullWidth
                    disabled={agentEditMode.status}
                    onChange={onAgentUsernameChange}
                    helperText={agentUsername.error}
                    error={agentUsername.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={phone.value}
                    placeholder={translate("agents.forms.hints.agent_phone")}
                    label={<Translate id="agents.forms.labels.agent_phone" />}
                    fullWidth
                    onChange={onPhoneChange}
                    helperText={phone.error}
                    error={phone.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={NID.value}
                    placeholder={translate("agents.forms.hints.agent_nid")}
                    label={<Translate id="agents.forms.labels.agent_nid" />}
                    fullWidth
                    onChange={onNidChange}
                    helperText={NID.error}
                    error={NID.error !== ""}
                  />
                )}
              </Translate>
            </Box>

            <Box mt={2}>
              <FormControl
                className={classes.formControl}
                fullWidth
                variant="outlined"
                size="small"
                error={gender.error !== ""}
              >
                <InputLabel id="type">
                  <Translate id="agents.forms.labels.agent_gender" />
                </InputLabel>
                <Select
                  label={<Translate id="agents.forms.labels.agent_gender" />}
                  value={gender.value}
                  onChange={onGenderChange}
                >
                  <MenuItem value="MALE">Male</MenuItem>
                  <MenuItem value="FEMALE">Female</MenuItem>
                </Select>
                <FormHelperText>{gender.error}</FormHelperText>
              </FormControl>
            </Box>

            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    type="password"
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={password.value}
                    placeholder={translate("agents.forms.hints.agent_password")}
                    label={
                      <Translate id="agents.forms.labels.agent_password" />
                    }
                    fullWidth
                    onChange={onPasswordChange}
                    disabled={agentEditMode.status}
                    helperText={password.error}
                    error={password.error !== ""}
                  />
                )}
              </Translate>
            </Box>

            <Box mt={2}>
              <FormControl
                className={classes.formControl}
                fullWidth
                variant="outlined"
                size="small"
                error={
                  role.error !== "" ||
                  roles.status == "error" ||
                  roles.status == "empty"
                }
                disabled={
                  roles.status == "error" ||
                  roles.status == "empty" ||
                  roles.status == "loading"
                }
              >
                <InputLabel id="type">
                  <Translate id="agents.forms.labels.agent_role" />
                </InputLabel>
                <Select
                  label={<Translate id="agents.forms.labels.agent_role" />}
                  value={role.value}
                  onChange={onRoleChange}
                >
                  {roles?.data?.map((rl, i) => (
                    <MenuItem value={rl.role_id}>{rl.name}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {roles.status == "error"
                    ? "Error getting roles, please refresh."
                    : roles.status == "empty"
                    ? "This agent does not have any role, create one in roles and privileges."
                    : role.error}
                </FormHelperText>
              </FormControl>
            </Box>

            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    value={pin.value}
                    placeholder={translate("agents.forms.hints.agent_pin")}
                    label={<Translate id="agents.forms.labels.agent_pin" />}
                    fullWidth
                    onChange={onPinChange}
                    helperText={pin.error}
                    error={pin.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setAddNewAgentOpen(false);
              }}
              variant="outlined"
              color="primary"
            >
              <Translate id="agents.forms.buttons.cancel" />
            </Button>
            <Button
              disabled={agents.saving}
              variant="contained"
              color="primary"
              onClick={onRegisterAgentClick}
              disableElevation
            >
              {agents.saving ? (
                <CircularProgress size={23} />
              ) : agentEditMode.status ? (
                "Save"
              ) : (
                <Translate id="agents.forms.buttons.register" />
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* //////////////////////////////////// */}

        {/* /////////////////////////////////////// */}

        <Box
          height={100}
          width={1}
          borderRadius="4px 4px 0px 0px"
          bgcolor="secondary.main"
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          flexDirection="column"
          p={2}
        >
          {/* <Typography color="textSecondary" style={{ color: "#fff" }}>
            <b>Email:</b>
            {agent.user_email}
          </Typography>
          <Typography color="textSecondary" style={{ color: "#fff" }}>
            <b> Phone:</b>
            {agent.user_phone}
          </Typography> */}
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box p={3}>
              <Avatar className={classes.avatar}>
                <Person />
              </Avatar>

              <Box display="flex" mt={1}>
                <Box>
                  <Typography variant="h5">
                    {agent.name}
                  </Typography>

                  <Typography color="textSecondary" gutterBottom>
                    Code:{agent.agent_code}
                  </Typography>

                  <Box mt={2}>
                    <Box width={1} mb={2}>
                      <Box display="flex">

                        {process.env.REACT_APP_INIATORS.includes(accountData.user_name) && <Button
                          color="primary"
                          variant="contained"
                          size="large"
                          disableElevation
                          onClick={() =>
                            setAgentTopup({ ...agentTopup, open: true })
                          }
                        >
                          Request top up
                        </Button>}

                        
                        <Box ml={2} />
                       
                          <Button
                            color="primary"
                            variant="outlined"
                            size="large"
                            startIcon={<BusinessCenterOutlined />}
                            disableElevation
                            onClick={() => {
                               getOperators(accountData.token,agent.user_id)
                                setSelectedAgent({...selectedAgent,data:agent,open:true})
                            }}
                          >
                            Operators
                          </Button>
                     
                      </Box>

                      {/* <Button
                          className={classes.btn}
                          style={{
                            color:
                              agent.status == "ENABLED"
                                ? Theme.palette.error.main
                                : Theme.palette.primary.main,
                          }}
                          size="large"
                          variant="contained"
                          startIcon={
                            togglingAgent ? (
                              <CircularProgress size={25} />
                            ) : agent.status == "ENABLED" ? (
                              <Block />
                            ) : (
                              <CheckCircle />
                            )
                          }
                          disabled={togglingAgent}
                          onClick={() =>
                            agent.status == "ENABLED"
                              ? setWarning(true)
                              : toggleAgent()
                          }
                          disableElevation
                        >
                          {agent.status == "ENABLED"
                            ? "Deactivate agent"
                            : "Reactivate agent"}
                        </Button> */}
                    </Box>
                    <Button
                      className={classes.btn}
                      color="inherit"
                      size="medium"
                      startIcon={<Add />}
                      disableElevation
                      onClick={() => setAddNewOpen(true)}
                    >
                      New device
                    </Button>{" "}
                    <Box pt={2} />
                    <Button
                      className={classes.btn}
                      color="inherit"
                      size="medium"
                      startIcon={<Add />}
                      disableElevation
                      onClick={() => setAddNewOutletOpen(true)}
                    >
                      New outlet
                    </Button>
                    <Box pt={2} />
                    {agent.agent_type_name == "CORPORATE AGENT" && (
                      <Button
                        className={classes.btn}
                        color="inherit"
                        size="medium"
                        startIcon={<Add />}
                        disableElevation
                        onClick={() => setAddNewAgentOpen(true)}
                      >
                        New assistant
                      </Button>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            <List>
              {agentAccount.loading ? (
                [1, 2, 3, 4, 5].map((item, i) => (
                  <ListItem key={i}>
                    <ListItemText
                      primary={
                        <Skeleton
                          variant="text"
                          width={"100%"}
                          style={{ borderRadius: 7 }}
                        />
                      }
                    />
                  </ListItem>
                ))
              ) : (
                <>
                  <ListItem>
                    <ListItemIcon>
                      <AccountCircle />
                    </ListItemIcon>
                    <ListItemText primary="Account number:" />
                    <ListItemSecondaryAction>
                      <Typography variant="subtitle1" color="textSecondary">
                        {agentAccount.data.account_number}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>

                  <Permissions permissions="CAN_VIEW_AGENT_WALLET_BALANCE">
                    <>
                      <ListItem>
                        <ListItemIcon>
                          <Money />
                        </ListItemIcon>
                        <ListItemText primary="Opening balance:" />
                        <ListItemSecondaryAction>
                          <Typography color="secondary">
                            <b>
                              {new Validator().formatMoney(
                                agentAccount.data.opening_balance
                              )}
                              {agentAccount.data.currency_code}
                            </b>
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <AccountBalance />
                        </ListItemIcon>
                        <ListItemText primary="Current balance:" />
                        <ListItemSecondaryAction>
                          <Typography color="primary">
                            <b>
                              {new Validator().formatMoney(
                                agentAccount.data.current_balance
                              )}{" "}
                              {agentAccount.data.currency_code}
                            </b>
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem>
                        <ListItemIcon>
                          <Money />
                        </ListItemIcon>
                        <ListItemText primary="Closing balance:" />
                        <ListItemSecondaryAction>
                          <Typography color="secondary">
                            <b>
                              {new Validator().formatMoney(
                                agentAccount.data.reserved_amount
                              )}{" "}
                              {agentAccount.data.currency_code}
                            </b>
                          </Typography>
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  </Permissions>
                  <ListItem>
                    <ListItemIcon>
                      <VpnLock />
                    </ListItemIcon>
                    <ListItemText primary="Account status:" />
                    <ListItemSecondaryAction>
                      <Switch
                        color="primary"
                        disabled={agentAccount.toggling}
                        value={agentAccount.data.status}
                        checked={agentAccount.data.status == "ENABLED"}
                        onChange={toggleAccount}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                </>
              )}
            </List>
          </Grid>

          <Grid item xs={12} md={8}>
            <Box pt={3} display="flex" justifyContent="center">
              <ButtonGroup color="primary">
                <Button
                  className={classes.btn}
                  size="medium"
                  variant={choice == 0 ? "contained" : "outlined"}
                  disableElevation
                  onClick={() => setChoice(0)}
                >
                  Devices
                </Button>

                <Button
                  className={classes.btn}
                  variant={choice == 1 ? "contained" : "outlined"}
                  size="medium"
                  disableElevation
                  onClick={() => setChoice(1)}
                >
                  Outlets
                </Button>

                {agent.agent_type_name == "CORPORATE AGENT" && (
                  <Button
                    className={classes.btn}
                    variant={choice == 2 ? "contained" : "outlined"}
                    size="medium"
                    disableElevation
                    onClick={() => setChoice(2)}
                  >
                    Assistants
                  </Button>
                )}
                <Button
                  className={classes.btn}
                  variant={choice == 3 ? "contained" : "outlined"}
                  size="medium"
                  disableElevation
                  onClick={() => setChoice(3)}
                >
                  Transactions
                </Button>
              </ButtonGroup>
            </Box>

            {choice == 0 ? (
              <Box mt={2}>
                {devices.loading && <LinearProgress />}
                <MUIDataTable
                  title={"List of devices"}
                  data={devices.data}
                  columns={columns}
                  options={options}
                />
              </Box>
            ) : choice == 1 ? (
              <Box>
                <Box mt={2}>
                  {allOutlets.loading && <LinearProgress />}
                  <MUIDataTable
                    title={"List of outlets"}
                    data={allOutlets.data}
                    columns={outletColumns}
                    options={outletOptions}
                  />
                </Box>
              </Box>
            ) : choice == 2 ? (
              <Box mt={2}>
                {agents.loading && <LinearProgress />}
                <MUIDataTable
                  title={"List of assistants"}
                  data={agents.data}
                  columns={agentsColums}
                  options={agentsOptions}
                />
              </Box>
            ) : (
              <Box mt={2}>
                <Grid container spacing={2}>
                  {transactions?.keys?.map((tr, i) => (
                    <Grid item xs={12} sm={6} lg={6}>
                      <Paper elevation={0} className={classes.paper}>
                        <Box width={1}>
                          <Box display="flex" width={1}>
                            <Box flexGrow={1}>
                              <Typography color="textSecondary">
                                {tr}
                              </Typography>
                              {/* <Typography color="textSecondary">
                          {transactions?.groups[tr][0].item_name}
                        </Typography> */}
                            </Box>
                            {<AcUnit />}
                          </Box>
                          <Box
                            mt={1}
                            mb="4px"
                            display="flex"
                            alignItems="flex-end"
                            justifyContent="space-between"
                            width={1}
                          >
                            <Tooltip
                              title={transactions?.groups[tr].length}
                              arrow
                              placement="top"
                            >
                              <Typography variant="h5">
                                {new Validator().formatNumber(
                                  transactions?.groups[tr].length
                                )}
                              </Typography>
                            </Tooltip>

                            <Typography color="primary" align="right">
                              {new Validator().formatMoney(
                                new Validator().sum(
                                  transactions?.groups[tr],
                                  "amount"
                                )
                              )}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
                <Box mt={2} />
                {transactions.loading && <LinearProgress />}
                <MUIDataTable
                  title={"Agent transactions"}
                  data={transactions.data}
                  columns={transactionsColums}
                  options={transactionsOptions}
                />
              </Box>
            )}
          </Grid>
        </Grid>

        <Box mt={3} />
      </div>
    </MuiPickersUtilsProvider>
  );
}

function CustomDevicesToolbar(props) {
  const { toggleDevice, displayData, selectedRows } = props;

  var check = displayData[selectedRows?.data[0]?.index].data[4] == "ENABLED";

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            disabled={props.toggling}
            checked={check}
            onChange={() =>
              // alert(JSON.stringify(displayData[selectedRows?.data[0]?.index]))
              toggleDevice(
                displayData[selectedRows?.data[0]?.index]?.data[0],
                selectedRows?.data[0]?.dataIndex
              )
            }
            value="vertical"
            color="primary"
          />
        }
        label={check ? "Deactivate device" : "Activate device"}
      />
    </div>
  );
}

function CustomAgentsToolbar(props) {
  const { toggleAssistant, displayData, selectedRows, openEdit } = props;

  var check = displayData[selectedRows?.data[0]?.index].data[4] == "ENABLED";

  return (
    <Box display="flex" alignItems="center">
      <FormControlLabel
        control={
          <Switch
            disabled={props.toggling}
            checked={check}
            onChange={() => {
              toggleAssistant(
                displayData[selectedRows?.data[0]?.index]?.data[0],
                selectedRows?.data[0]?.dataIndex
              );
            }}
            value="vertical"
            color="primary"
          />
        }
        label={check ? "Deactivate agent" : "Activate agent"}
      />

      <Box mr={2} ml={2}>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          startIcon={<Edit />}
          onClick={() =>
            openEdit(displayData[selectedRows?.data[0]?.index]?.data[0])
          }
        >
          Edit
        </Button>
      </Box>
    </Box>
  );
}
export default withLocalize(GlobalAgentDetails);
